/*
module.exports = {
   install: function (Vue,locale) {
      var moment = require('moment')
      moment.locale(locale)
      Vue.prototype.$moment = moment
   }
 }
*/
 import moment from 'moment'

 class VueMoment  {
  install(Vue,locale) {
    moment.locale(locale)
    Vue.prototype.$moment = moment
    //Vue.prototype.$axios = this
 }

}

export default new VueMoment 
